import { getCurrentInstance, ref, computed } from 'vue';
import autoBusinessAPI from '../../apis/di/autoBusinessAPI';
import { MSConstant } from '@/commons/wildcards';
import popupUtil from '@/commons/popupUtil.js';
import { showError } from '@/commons/globalMessage';
import { useStore } from 'vuex';
import { ModuleAutoBusinessCache } from '@/stores/moduleConst';
export const useQuickAccountingVoucher = ({ gridDetails }) => {
  const refType = ref(0);
  // const accountingActions = ref([]);
  const { proxy } = getCurrentInstance();
  const store = useStore();

  const accountingActions = computed(() => {
    const actions = store.getters[`${ModuleAutoBusinessCache}/items`];
    let datas = actions.filter(x => !x.inactive && x.ref_type == refType.value)?.sortObject('auto_business_name') || [];
    return datas.map(x => {
      return {
        text: x.auto_business_name,
        id: x.auto_business_id,
        ref_type: x.ref_type
      };
    });
  });

  /**
   * Lấy các dòng định khoản nhanh theo type
   * NCPHUOC 05/07/2022
   */
  const getAutoBusinessByRefType = () => {
  };

  /**
   * binding data business vào model
   * @param {*} data
   * NCPHUOC 05/07/2022
   */
  const bindingDataAutoBusiness = data => {
    if (data) {
      let index = 0;
      const indexAccouting = 0,
        indexAccoutingParallel = 1;

      for (const key in gridDetails) {
        const accoutings = data[index];
        //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
        if (Object.hasOwnProperty.call(gridDetails, key)) {
          if (proxy.model && Array.isArray(data[index]) && accoutings.length > 0) {
            //Xóa hết các dòng trắng
            proxy.model[key] = proxy.model[key].filter(x => x.state !== MSConstant.ModelState.Empty);
            const oldValue = proxy.model[key].filter(x => x.state !== MSConstant.ModelState.Delete);
            //Chuyển mode của dòng detail thành insert hết
            accoutings.forEach(element => {
              element.state = MSConstant.ModelState.Insert;
            });

            //Nếu đã có dữ liệu sẽ thực hiện insert thêm, nếu ko sẽ thay thế hết
            if (oldValue.length > 0) {
              switch (index) {
                case indexAccouting:
                  const mapKeys = Object.keys(accoutings[0]).filter(x => x !== 'RecordVersion');
                  let selectedRowIndex = oldValue.findIndex(
                    x => x.selected && x.state !== MSConstant.ModelState.Delete
                  );

                  if (selectedRowIndex === -1) {
                    //Nếu ko có dòng nào được select thì sẽ chọn dòng đầu tiên
                    selectedRowIndex = oldValue.findIndex(x => x.state !== MSConstant.ModelState.Delete);
                  }

                  //Map row đầu tiên
                  mapKeys.forEach(key => {
                    if (key === 'state') return;
                    oldValue[selectedRowIndex][key] = accoutings[0][key];
                  });

                  changeModelState(oldValue[selectedRowIndex]);
                  //Push các dòng còn lại vào ngay sau dòng được chọn
                  for (let index = 1; index < accoutings.length; index++) {
                    const element = accoutings[index];
                    oldValue.insertAt(index + selectedRowIndex, element);
                  }
                  break;
                case indexAccoutingParallel:
                  accoutings.forEach(x => proxy.model[key].unshift(x));
                  break;
              }
            } else {
              proxy.model[key] = accoutings;
            }
          }
        }
        index++;
      }

      if (proxy.customDataRowGrid && typeof proxy.customDataRowGrid == 'function') {
        // call api get thông tin hàng hóa
        proxy.customDataRowGrid();
      }
    }
  };

  /**
   * Thay đổi state của bản ghi theo row hiện tại
   * @param {*} row
   * NCPHUOC 06/07/2022
   */
  const changeModelState = row => {
    switch (row.state) {
      case MSConstant.ModelState.Insert:
      case MSConstant.ModelState.Empty:
        row.state = MSConstant.ModelState.Insert;
        break;
      case MSConstant.ModelState.Delete:
        break;
      case MSConstant.ModelState.Update:
        break;
      default:
        row.state = MSConstant.ModelState.Update;
        break;
    }
  };
  /**
   * Xử lý click định khoản nhanh
   * @param {*} autoBusinessId
   * NCPHUOC 05/07/2022
   */
  const clickQuickAccounting = autoBusinessId => {
    autoBusinessAPI.getAutoBusinessDetailById(autoBusinessId).then(res => {
      if (proxy.beforeBindDataAutoBusiness && typeof proxy.beforeBindDataAutoBusiness == 'function') {
        proxy.beforeBindDataAutoBusiness(res);
      }
      bindingDataAutoBusiness(res);
    });
  };

  /**
   * Submit call back từ form thêm mới định khoản tự động
   * @param {*} data
   * NCPHUOC 05/07/2022
   */
  const submitAddAutoBusiness = data => {
    //Check lại xem có đúng reftype được thêm hay không
    if (data && data.auto_business_id && data.ref_type === refType.value) {
      accountingActions.value.unshift({
        text: data.auto_business_name,
        id: data.auto_business_id,
      });

      //clickQuickAccounting(data.auto_business_id);
    }
  };

  /**
   * Show form thêm mới định khoản tự động
   * NCPHUOC 05/07/2022
   */
  const addAutoBusiness = () => {
    popupUtil.show('AutoBusinessDetail', {
      mode: MSConstant.FormState.Add,
      options: {
        submit: submitAddAutoBusiness,
      },
      data: refType.value,
    });
  };

  /**
   * Thực hiện lưu thành định khoản tự động mới
   * NCPHUOC 06/07/2022
   */
  const saveAsNewAutoBusiness = () => {
    const check = proxy.$ms.commonFn.checkPermissionWithSubSystemCode(
      proxy.$ms.constant.Permission.Add,
      'AutoBusiness'
    );
    if (!check) {
      let msg = proxy.$t('i18nBaseForm.Validate.NotPermission');
      let title = proxy.$t('i18nBaseForm.Validate.TitleNotPermission');
      showError(msg, title);
      throw msg;
    }
    if (proxy.model) {
      const cloneModel = JSON.parse(JSON.stringify(proxy.model));
      const refDetail = [],
        refDetailParallel = [];
      for (const key in gridDetails) {
        const element = cloneModel[key];
        const keyRef = gridDetails[key];
        const bindingElements = element.filter(
          x => x.state !== MSConstant.ModelState.Empty && x.state !== MSConstant.ModelState.Delete
        );
        if (keyRef === proxy.refDetail) {
          refDetail.push(...bindingElements);
        }
        if (keyRef === proxy.refDetailParallel) {
          refDetailParallel.push(...bindingElements);
        }
      }
      // for 2 list để gán thêm state là add
      //NTLOC 28.07.2022
      if (refDetail != null && refDetail.length > 0) {
        for (var i = 0; i < refDetail.length; i++) {
          refDetail[i].state = MSConstant.ModelState.Insert;
        }
      }
      if (refDetailParallel != null && refDetailParallel.length > 0) {
        for (var i = 0; i < refDetailParallel.length; i++) {
          refDetailParallel[i].state = MSConstant.ModelState.Insert;
        }
      }
      popupUtil.show('AutoBusinessDetail', {
        mode: MSConstant.FormState.Add,
        options: {
          data: {
            ref_type: refType.value,
            AutoBusinessDetail: refDetail,
            AutoBusinessDetailParalell: refDetailParallel,
          },
          submit: submitAddAutoBusiness,
        },
      });
    }
  };
  return {
    refType,
    getAutoBusinessByRefType,
    clickQuickAccounting,
    accountingActions,
    addAutoBusiness,
    saveAsNewAutoBusiness,
  };
};
